import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

function ProtectedRoute({ children }) {
  const { isAuthenticated, user } = useSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // If user data is not loaded yet, wait (could show loader here if needed)
  // For now, we allow access since authentication is verified
  if (!user) {
    return children
  }

  // If first login is required (first_login is false), redirect to reset password
  if (user.first_login === false) {
    return <Navigate to="/reset-password" replace />
  }

  return children
}

export default ProtectedRoute

